import React from "react";
import { Route, Routes as ReactRoutes } from "react-router-dom";

// x---------------------------------x All Pages Access x---------------------------------x
import Index from "./Partials/Universal/Dashboard/Index";
import Transaction from "./Partials/Universal/Transaction/Transaction";
import Accounts from "./Partials/Universal/Accounts/Accounts";
import Investment from "./Partials/Universal/Investment/Investment";
import CreditCards from "./Partials/Universal/CreditCards/CreditCards";
import Loans from "./Partials/Universal/Loans/Loans";
import Services from "./Partials/Universal/Services/Service/Service";
import BusinessLoan from "./Partials/Universal/Services/businessLoan/BusinessLoan";
import SavingsAccount from "./Partials/Universal/Services/SavingsAccount/SavingsAccount";
import LifeInsurance from "./Partials/Universal/Services/LifeInsurance/LifeInsurance";
import PersonalLoans from "./Partials/Universal/Services/PersonalLoans/PersonalLoans";
import Privileges from "./Partials/Universal/Privileges/Privileges";
import Setting from "./Partials/Universal/Setting/Setting";

const Routes = () => {
  return (
    <ReactRoutes>

      {/* // x---------------------------------x All Pages Routes Section x---------------------------------x */}
      <Route exact path="/" element={<Index />} />
      <Route exact path="/dashboard" element={<Index />} />
      <Route exact path="/transactions" element={<Transaction />} />
      <Route exact path="/accounts" element={<Accounts />} />
      <Route exact path="/investments" element={<Investment />} />
      <Route exact path="/Credit-cards" element={<CreditCards />} />
      <Route exact path="/loans" element={<Loans />} />
      <Route exact path="/services" element={<Services />} />
      <Route exact path="/business-loan" element={<BusinessLoan />} />
      <Route exact path="/savings-accounts" element={<SavingsAccount />} />
      <Route exact path="/life-Insurance" element={<LifeInsurance />} />
      <Route exact path="/personal-loans" element={<PersonalLoans />} />
      <Route exact path="/privileges" element={<Privileges />} />
      <Route exact path="/setting" element={<Setting />} />

    </ReactRoutes >
  );
};

export default Routes;
